const state = {
  dialog: {
    show: false,
    note: {}
  }
}

const getters = {
  dialogDeleteContentNoteStore: state => state.dialog
}

const mutations = {
  openDialogDeleteContentNote(state, note) {
    state.dialog.show = true
    state.dialog.note = note
  },
  closeDialogDeleteContentNote(state) {
    state.dialog.show = false 
    state.note = {}
  }
}

export default {
  state,
  getters,
  mutations
}